import { render, staticRenderFns } from "./his-chufang.vue?vue&type=template&id=bdcac212&scoped=true&"
import script from "./his-chufang.vue?vue&type=script&lang=ts&"
export * from "./his-chufang.vue?vue&type=script&lang=ts&"
import style0 from "./his-chufang.vue?vue&type=style&index=0&id=bdcac212&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdcac212",
  null
  
)

export default component.exports